// extracted by mini-css-extract-plugin
module.exports = {"host":"language-switcher-module--host--3snyH","lang":"language-switcher-module--lang---c0au","flag":"language-switcher-module--flag--1bRoa"};